const demoData = [
  {
    kpi_name: 'Overall',
    kpi_value: 0
  },
  {
    kpi_name: 'Steep',
    kpi_value: 0
  },
  {
    kpi_name: 'Speed',
    kpi_value: 0
  },
  {
    kpi_name: 'Technical',
    kpi_value: 0
  },
  {
    kpi_name: 'Corners',
    kpi_value: 0
  }
];
export { demoData };
